(() => {
  angular
    .module('app.ics')
    .controller('ManageInterceptionCodesController', ManageInterceptionCodesController);

  ManageInterceptionCodesController.$inject = [
    '$sce',
    '$scope',
    '$timeout',
    'model',
    'close',
    'TrackpointService',
  ];

  function ManageInterceptionCodesController(
    $sce,
    $scope,
    $timeout,
    model,
    close,
    TrackpointService,
  ) {
    const vm = this;

    vm.campaignTabActive = true;
    vm.campaignsLoaded = false;
    vm.isBtnAddCampaignsEnabled = false;

    vm.isSearchLoading = false;

    vm.campaigns = [];
    vm.codes = [];
    vm.filter = '';

    vm.campaignsAdded = [];
    vm.campaignsToAdd = [];

    $scope.highlight = function(text, search) {
      if (!search) {
        return $sce.trustAsHtml(text);
      }
      return $sce.trustAsHtml(text.replace(new RegExp(search, 'gi'), '<span class="highlight yellow">$&</span>'));
    };

    if (model && model.length > 0) {
      vm.codes = model.slice();

      vm.campaignsAdded = vm.codes.reduce(function(memo, campaign) {
        if (campaign.codeType === 1 || campaign.codeType === 2) {
          memo.push(campaign);
        }
        return memo;
      }, []);
    }

    function isCampaignExists(pid) {
      var found = _.find(vm.codes, function(c) {return c.id == pid; });
      return  found != undefined && found != null;
    };

    function isElementExists(code){
      var found = _.find(vm.codes, function(c) {return c.code == code; });
      return found != undefined && found != null;
    };

    vm.currentPage = 1;
    vm.campaignsPerPage = 6;
    vm.campaignsCurrentPage = [];
    vm.totalPages = () => Math.round(vm.campaigns.length / vm.campaignsPerPage);
    vm.showPagination = () => vm.campaigns.length > vm.campaignsPerPage;

    vm.isFirstPage = () => vm.currentPage === 1;
    vm.isLastPage = () => vm.currentPage * vm.campaignsPerPage >= vm.campaigns.length;

    const showPage = next => {
      vm.currentPage = vm.currentPage + next;
      vm.campaignsCurrentPage = [...vm.campaigns].splice((vm.currentPage - 1) * vm.campaignsPerPage, vm.campaignsPerPage);
    };

    vm.pageForward = () => { showPage(1); };
    vm.pageBackward = () => { showPage(-1); };

    const fetchCampaigns = () => {
      fetch(`https://${localStorage.getItem('ARApiDomain')}/campaigns?maxResults=1000`, {
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('idToken')}`,
          'Customer-Id': $('#current-user').data('company-id')
        }
      })
      .then(response => response.json())
      .then(response => {
        vm.campaigns = response.data.map(campaign => ({
          pid: campaign.id,
          name : campaign.name,
          cid : campaign.cid,
          imps : campaign.events,
          isAdded: isCampaignExists(campaign.id)
        }));

        vm.campaignsLoaded = true;

        showPage(0);
        $scope.$apply();
      });
    }

    fetchCampaigns();

    const isEqual = (a1, a2) => {
      const namesA1 = a1.map(({ name }) => name);
      const namesA2 = a2.map(({ name }) => name);
      return angular.equals(namesA1.sort(), namesA2.sort());
    }

    vm.manageCampaign = p => { // add or remove campaign
      p.isAdded = !p.isAdded;
      var code = `${p.cid}*`;
      var id = p.pid;
      if (p.isAdded) {
        var campaign = {
          id,
          code,
          name: p.name,
          codeType : 1,
        };
        vm.codes.push(campaign);
        vm.campaignsToAdd.push(campaign);
      } else {
        var index = -1;
        var found = _.find(vm.codes, function(c, i) {
          if (c.code == code) {
            index = i;
            return true;
          }
        });

        if (index >= 0) {
          const removed = vm.codes.splice(index, 1);
          vm.campaignsToAdd.splice(vm.campaignsToAdd.indexOf(removed), 1);
        };
      }

      vm.isBtnAddCampaignsEnabled = !isEqual(vm.campaignsToAdd, vm.campaignsAdded);
    };

    vm.manageTrackpoint = t => { // add or remove trackpoint
      t.isAdded = !t.isAdded;
      var code = t.code;
      var id = t.tailcode;
      if (t.isAdded) {
        const codeItem = {
          id,
          code,
          name: t.name,
          codeType : 2,
        };

        vm.codes.push(codeItem);
        vm.campaignsToAdd.push(codeItem);
      } else {
        var index = -1;
        var found = _.find(vm.codes, function(c, i) {
          if (c.code == code) {
            index = i;
            return true;
          }
        });

        if (index >= 0) {
          const removed = vm.codes.splice(index, 1);
          vm.campaignsToAdd.splice(vm.campaignsToAdd.indexOf(removed), 1);
        }
      }

      vm.isBtnAddCampaignsEnabled = !isEqual(vm.campaignsToAdd, vm.campaignsAdded);
    };

    vm.addWildcard = function() {
      vm.codes.push({
        id: 0,
        code: `${vm.filter}*`,
        name: vm.filter,
        codeType: 3,
      });
      vm.filter = '';
    };

    vm.saveCodes = function() {
      close(vm.codes, 500);
    };

    var searchTimer = null;
    vm.trackingPoints = [];

    $scope.$watch(function () {
      return vm.filter;
    }, function (key) {
      if (searchTimer) {
        $timeout.cancel(searchTimer);
      }
      if (key.length > 2) {
        $timeout(function () {
          vm.isSearchLoading = true;
          vm.trackingPoints.length = 0;
        }, 0);

        searchTimer = $timeout(function () {
          TrackpointService.search({'term': key}, function (searchResult) {
            angular.forEach(searchResult.data, function (campaign) {
              angular.forEach(campaign.trackpoints, function (t) {
                var point =  {
                  name: t.name,
                  cid: t.cid,
                  tailcode: t.tailcode,
                  code: t.cid + t.tailcode,
                  isAdded: isElementExists(t.cid + t.tailcode),
                  visible: true
                };
                vm.trackingPoints.push(point);
              })
            });

            vm.isSearchLoading = false;
          });
        }, 500);
      } else {
        vm.isSearchLoading = false;
      }
    });
  }
})();
